'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'forklift';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f47a';
var svgPathData = ['M0 424A87.9 87.9 0 1 0 175.9 424 87.9 87.9 0 1 0 0 424zm128 0a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm112 0a88 88 0 1 0 176 .2 88 88 0 1 0 -176-.2zm128 0a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM448 32l0 416c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32z', 'M160 96l85.8 0 68.6 160-90.4 0-64-96 0-64zM96 80l0 80-32 0c-35.3 0-64 28.7-64 64L0 424c0-48.6 39.4-88 88-88s88 39.4 88 88c0 8.3-1.2 16.4-3.3 24l70.6 0c-2.2-7.6-3.3-15.7-3.3-24 0-48.6 39.4-88 88-88 21.3 0 40.8 7.5 56 20.1l0-90.3c0-6.7-1.4-13.1-3.9-18.9L300.5 61.1C292.9 43.4 275.6 32 256.3 32L144 32c-26.5 0-48 21.5-48 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faForklift = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;